var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "signature-zone" }, [
    _c("label", { staticClass: "signature-zone__subject" }, [
      _vm._v(_vm._s(_vm.$t("signature"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("InputField", {
          staticClass: "time-input",
          attrs: {
            showColon: false,
            value: _vm.getSignatureAttribute("time"),
            label: _vm.$t("time"),
            inputTip: _vm.$t("error.invalidTime"),
            inputCheckType: "string",
            pattern: _vm.regex.time,
            showFlag: false,
            readonly: !_vm.editStatus,
            required: !!_vm.signatures.time,
          },
          on: {
            updateValue: function (val) {
              return _vm.updateValue(val.trim(), "time")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("label", { staticClass: "label-title large-12" }, [
          _vm._v(
            _vm._s(
              _vm.isHandover
                ? _vm.$t("hotb.signatures.takenOverBy")
                : _vm.$t("hotb.signatures.handedOverBy")
            )
          ),
        ]),
        _vm._v(" "),
        _c("HotbSignatureSection", {
          ref: "headerSignatureRef",
          attrs: {
            editStatus: _vm.editStatus,
            signatureMsg: _vm.$t("hotb.signatures.tenantSignatory"),
          },
          model: {
            value: _vm.headerNames,
            callback: function ($$v) {
              _vm.headerNames = $$v
            },
            expression: "headerNames",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "label",
        { staticClass: "label-title columns small-1 medium-1 large-1" },
        [_vm._v(_vm._s(_vm.$t("For")) + ":")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.tenant))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "small-12 large-8" },
        [
          _c("InputField", {
            attrs: {
              label: _vm.$t("hotb.signatures.presentAddress"),
              showColon: false,
              showFlag: false,
              placeholder: _vm.$t("hotb.signatures.placeHolder"),
              value: _vm.getSignatureAttribute("presentAddress"),
              readonly: !_vm.editStatus,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateValue(val, "presentAddress")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-12 large-8" },
        [
          _c("InputField", {
            attrs: {
              label: _vm.$t("hotb.signatures.contactPerson"),
              showColon: false,
              showFlag: false,
              value: _vm.getSignatureAttribute("contactPerson"),
              readonly: !_vm.editStatus,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateValue(val, "contactPerson")
              },
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "columns column-padding small-12 medium-12 large-6" },
        [
          _c("InputField", {
            attrs: {
              showColon: false,
              showFlag: false,
              label: _vm.$t("general.email"),
              value: _vm.getSignatureAttribute("email"),
              readonly: !_vm.editStatus,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateValue(val, "email")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "columns small-12 medium-12 large-2" },
        [
          _c("InputField", {
            attrs: {
              label: _vm.$t("hotb.signatures.telephoneNo"),
              showColon: false,
              showFlag: false,
              value: _vm.getSignatureAttribute("teleNo"),
              readonly: !_vm.editStatus,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateValue(val, "teleNo")
              },
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("label", { staticClass: "label-title large-12" }, [
          _vm._v(
            _vm._s(
              _vm.isHandover
                ? _vm.$t("hotb.signatures.handedOverBy")
                : _vm.$t("hotb.signatures.takenOverBy")
            )
          ),
        ]),
        _vm._v(" "),
        _c("HotbSignatureSection", {
          ref: "footerSignatureRef",
          attrs: { editStatus: _vm.editStatus },
          model: {
            value: _vm.footerNames,
            callback: function ($$v) {
              _vm.footerNames = $$v
            },
            expression: "footerNames",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "label",
        { staticClass: "label-title columns small-1 medium-1 large-1" },
        [_vm._v(_vm._s(_vm.$t("For")) + ":")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "columns" },
        [
          _vm._l(_vm.subsidiary, function (item, index) {
            return _c("div", { key: index, staticClass: "site-subsidiary" }, [
              _vm._v("\n        " + _vm._s(item) + "\n      "),
            ])
          }),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("hotb.signatures.ownerOfBuilding"))),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }